import { createMobileMenuWidget } from '@/widgets/MobileMenuWidget';
import { createAuthWidget } from '@/widgets/AuthWidget';
import { createFeedbackWidget } from '@/widgets/FeedbackWidget';
import { createFavoritesWidget } from '@/widgets/FavoritesWidget';
import { createSeeBanerWidget } from '@/widgets/SeeBanerWidget';

export const mobileMenuWidget = createMobileMenuWidget(
    document.querySelector('#mobile-menu-widget')!
);

export const feedbackWidget = createFeedbackWidget(
    document.querySelector('#feedback-widget')!
);

export const seeBanerWidget = createSeeBanerWidget(
    document.querySelector('#seeBanerWidget')!
);

export const favorites = createFavoritesWidget(
    document.querySelector('#favorites-widget')!
);

export const authWidget = createAuthWidget(document.querySelector('#auth-widget')!);
